import { createWebHistory, createRouter } from "vue-router";
import Login from '../components/Login.vue'
import WsSearch from '../components/WsSearch.vue'
import Error from '../components/Error.vue';

const routes = [
  {
    path: '/ws-search',
    name: 'wsSearch',
    component: WsSearch,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/error',
    name: "Error",
    component: Error,  
    meta: {
      requiresAuth: true
    }      
  },
  {
    path: '/:pathMatch(.*)*',
    component: Login
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (!localStorage.getItem('user-password')) next('/login')
    else next()
  } else next()
})

export default router;
